import React from 'react'
import { SVGIconProps } from '../types'
const SvgHomeWork = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M8.17 5.7 1 10.48V21h5v-8h4v8h5V10.25z" />
    <path fill="none" d="M17 7h2v2h-2z" />
    <path d="M10 3v1.51l2 1.33L13.73 7H15v.85l2 1.34V11h2v2h-2v2h2v2h-2v4h6V3zm9 6h-2V7h2z" />
  </svg>
)
export default SvgHomeWork
